import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Usuários</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Usuários</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Novo", -1)
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Nome "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "cpf" }, "CPF", -1)
const _hoisted_15 = { class: "form-group col-12 col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("E-mail "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_17 = { class: "form-group col-12 col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Telefone", -1)
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "id_access_profile" }, [
  /*#__PURE__*/_createTextVNode("Perfil de Acesso "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group col-12 col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, [
  /*#__PURE__*/_createTextVNode("Login "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_24 = { class: "form-group col-12 col-md-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Senha "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_26 = { class: "form-group col-12 col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "confirmPassword" }, [
  /*#__PURE__*/_createTextVNode("Confirma Senha "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_28 = { class: "card-footer text-center" }
const _hoisted_29 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                id: "name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.name), 513), [
                [_vShow, _ctx.errors.name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                id: "cpf",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.cpf) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.cpf }]),
                style: {"max-width":"200px"}
              }, null, 2), [
                [_vModelText, _ctx.row.cpf],
                [_directive_maska, '###.###.###-##']
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.cpf), 513), [
                [_vShow, _ctx.errors.cpf != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.email) = $event)),
                type: "email",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.email }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.email]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.email), 513), [
                [_vShow, _ctx.errors.email != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                id: "phone",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.row.phone) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.phone }]),
                style: {"max-width":"200px"},
                maxlength: "15"
              }, null, 2), [
                [_vModelText, _ctx.row.phone],
                [_directive_maska, ['(##) ####-####', '(##) # ####-####']]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.phone), 513), [
                [_vShow, _ctx.errors.phone != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("select", {
                id: "id_access_profile",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.row.id_access_profile) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.id_access_profile }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemAccessProfiles, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_21))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.id_access_profile]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.id_access_profile), 513), [
                [_vShow, _ctx.errors.id_access_profile != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                id: "username",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.row.username) = $event)),
                type: "email",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.username}]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.username]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.username), 513), [
                [_vShow, _ctx.errors.username != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.row.password) = $event)),
                type: "password",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.password}]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.password]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.password), 513), [
                [_vShow, _ctx.errors.password != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.confirmPassword) = $event)),
                type: "password",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.confirmPassword}]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.confirmPassword]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.confirmPassword), 513), [
                [_vShow, _ctx.errors.confirmPassword != null]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-warning",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.goBack()))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-success",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.save()))
              }, "Gravar")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}